import {
  GET_USER_STATISTICS,
  GET_USER_STATISTICS_SUCCESS,
} from "../../actions/statistics/types";

const initialState = {
  userStatisticsLoading: false,
  userStatisticsData: {values:[],labels:[]},
};

export const users = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_USER_STATISTICS:
      return {
        ...state,
        userStatisticsLoading: true,
      };
    case GET_USER_STATISTICS_SUCCESS:
      return {
        ...state,
        userStatisticsLoading: false,
        userStatisticsData: payload,
      };
    default: {
      return state;
    }
  }
};
